package com.exura.features.localization.domain.manager

import com.exura.features.localization.domain.model.Language

object LocalizationManager {
    private var _currentLanguage: Language = Language.POLISH
    val currentLanguage: Language
        get() = _currentLanguage

    fun setLanguage(language: Language) {
        _currentLanguage = language
    }
}
